import { FlexColumn } from '@gorila-shared-ui/components';
import { FileRow, FileUploader } from 'baseui/file-uploader';
import { ALL_EXTENSIONS } from '../../constants/app';

type Props = {
  file?: FileRow;
  onFileChange: (file?: FileRow) => void;
  onBlur?: () => void;
  acceptExtensions?: string[];
};

function DocumentUploader({ file, onFileChange, onBlur, acceptExtensions = ALL_EXTENSIONS }: Readonly<Props>) {
  return (
    <FlexColumn>
      <FileUploader
        accept={acceptExtensions}
        fileRows={file ? [file] : undefined}
        setFileRows={(rows) => {
          if (rows.length > 1) {
            onFileChange(rows[1]);
          } else {
            onFileChange(rows[0]);
          }
        }}
        buttonText="Buscar archivo"
        contentMessage="o arrastra un archivo aquí para subir"
        itemPreview
        onBlur={onBlur}
        multiple={false}
        overrides={{
          FileRowUploadText: {
            props: (props) => {
              if (props?.['aria-invalid']) {
                return { ...props, children: `Sube archivos: ${acceptExtensions.join(', ')} para un formato válido` };
              }
              if (props.children === 'Uploading') {
                return {
                  ...props,
                  children: 'Cargando...',
                };
              }
              return { ...props, children: 'Archivo válido' };
            },
          },
        }}
      />
    </FlexColumn>
  );
}

export default DocumentUploader;
